import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ServerUserSettingsSubspaceCtrl } from '../../../ts/controllers/ServerUserSettingsSubspaceCtrl';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { IServerUserInfo } from '../../../ts/models/IServerUserInfo';
import { SiteRoleOptionsResource } from '../../../userManagement/services/resources/SiteRoleOptions';
import { IGetUserSettingsResult } from '../../../ts/ServerApi/requests/GetUserSettingsRequest';
import { UserSpaceHeader } from '../SiteUserSpace/SiteUserSpaceHeader';
import { Subspace, TabbedSpace } from '../TabbedSpace';

export interface ServerUserSpaceProps extends ReactDirectiveProps {
  readonly user: IServerUserInfo;
  readonly userSettings: IGetUserSettingsResult;
  readonly userRefreshTokenCount: number;
  readonly isSessionUserSelf: boolean;
  readonly siteRoleOptions: SiteRoleOptionsResource;
}

export class ServerUserSpace extends React.PureComponent<ServerUserSpaceProps> {
  public render(): JSX.Element {
    const subspaces = getServerUserSubspaces({setupScope: this.setupScopeForSettings, angularContext: this.props.angularContext});
    return (
      <TabbedSpace
        subspaces={subspaces}
        activeSubspaceName={'settings'}
        urlForSubspace={this.urlForSubspace}
        mastheadElement={this.mastheadElement()}
        testIdPrefix={'serveruser'}
        spaceItemName={this.props.user.displayName}
      />
    );
  }

  private urlForSubspace = () => '';

  private mastheadElement = (): React.ReactNode => {
    return (
      <UserSpaceHeader
        item={this.props.user}
        inServerArea={true}
        siteRole={this.props.user.maxSiteRole}
        siteRoleOptions={this.props.siteRoleOptions}
        userSettings={this.props.userSettings}
        isSessionUserSelf={this.props.isSessionUserSelf}
        isSessionServerAdmin={true}
        isSessionSiteAdmin={false}
        isServerDomainFamilyActiveDirectory={false}
      />
    );
  }

  private setupScopeForSettings = (scope: ng.IScope) => {
    const childScope = scope.$new() as ServerUserSettingsSubspaceCtrl.Scope;
    childScope.isSessionUserSelf = this.props.isSessionUserSelf;
    childScope.userSettings = this.props.userSettings;
    childScope.userRefreshTokenCount = this.props.userRefreshTokenCount;
    childScope.serverUser = this.props.user;
    return childScope;
  }
}

function getServerUserSubspaces(props: AngularDirective.Props): ReadonlyArray<Subspace> {
  return [
    {
      name: 'settings',
      tabLabel: Messages.settings(),
      shouldRenderTabContentCount: false,
      renderContent: () => <SettingsSubspace {...props}/>
    }
  ];
}

const template = `<div ng-controller="ServerUserSettingsSubspaceCtrl" ng-include="'serverUserSettingsSubplace.html'"></div>`;
const SettingsSubspace = (props: AngularDirective.Props): JSX.Element => {
  // the parent div here is important to ensure AngularDirective plays nice when unmounting
  return (
    <div>
      <AngularDirective
        template={template}
        angularContext={props.angularContext}
        setupScope={props.setupScope}
      />
    </div>
  );
};
